import { Box, IconButton, Menu } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import {
  patchApproveRejectAsync,
  postAppsAsync,
} from './AppListStore/appListStoreSlice';
import SHAmodal from './AppListStore/SHAmodal';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import ApproveReject from './AppListStore/ApproveReject';
import { toast } from 'react-toastify';
export const appListColumn = [
  {
    Header: 'School Name',
    accessor: 'schoolId.schoolName',
  },
  {
    Header: 'package Name',
    accessor: 'packageName',
  },
  {
    Header: 'status',
    accessor: 'status',
  },
  {
    Header: 'Build Status',
    accessor: 'lastBuild.status',
  },
  {
    Header: 'Download',
    accessor: '',
    Cell: (val) => {
      const payload = val.cell.row.original;
      // const dispatch = useDispatch();
      // console.log('tehdhdhhd',payload)
      return (
        <>
          {payload &&
          payload.lastBuild &&
          payload.lastBuild.artefacts &&
          payload.lastBuild.artefacts[0] &&
          payload.lastBuild.artefacts[0].url ? (
            payload.lastBuild.artefacts[0].url === null ? (
              <></>
            ) : (
              <a
                href={payload.lastBuild.artefacts[0].url}
                download
                style={{ color: 'black' }}>
                Download
              </a>
            )
          ) : null}
        </>
      );
    },
  },
  { Header: 'Date Request', accessor: 'createdAt' },
  { Header: 'Date published', accessor: 'updatedAt' },
  {
    Header: 'Action',
    accessor: '',
    Cell: (val) => {
      const payload = val.cell.row.original;
      // console.log('abhijeet',payload)
      const dispatch = useDispatch();
      const [anchorEl, setAnchorEl] = React.useState(null);
      const open = Boolean(anchorEl);
      const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
      };
      const handleClose = () => {
        setAnchorEl(null);
      };
      const ITEM_HEIGHT = 48;
      const [openModal, setOpenModal] = useState(false);
      const [openModal1, setOpenModal1] = useState(false);
      return (
        <>
          {payload.status === 'rejected' ? (
            <></>
          ) : (
            <>
              <Box display="flex">
                <Box width={80} fontSize={14}>
                  <IconButton
                    aria-label="more"
                    aria-controls="long-menu"
                    aria-haspopup="true"
                    onClick={handleClick}>
                    <MoreVertIcon />
                  </IconButton>
                  <Menu
                    id="long-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={open}
                    onClose={handleClose}
                    PaperProps={{
                      style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: '20ch',
                      },
                    }}>
                    {/* {console.log('approve',payload.status)} */}
                    {payload.status === 'pending' ? (
                      <>
                        <ApproveReject
                          open={openModal1}
                          onClose={() => {
                            setOpenModal1(false);
                          }}
                          _id={payload._id}
                        />
                        <Box
                          onClick={() => {
                            setOpenModal1(true);
                            dispatch(
                              patchApproveRejectAsync({ _id: payload._id })
                            );
                          }}
                          sx={{
                            cursor: 'pointer',
                            py: 2,
                            textAlign: 'center',
                          }}>
                          approve/reject
                        </Box>
                      </>
                    ) : (
                      <></>
                    )}
                    {(payload && payload.lastBuild) ||
                    payload.status === 'pending' ||
                    payload.status === 'rejected' ? (
                      <></>
                    ) : (
                      // Abhijeet's code
                      // payload.lastBuild ? (
                      //   <></>
                      // ) : (
                      //   <></>
                      // )
                      <>
                        <Box
                          onClick={() => {
                            // dispatch(postAppsAsync({ _id: payload._id }));
                            try {
                              dispatch(postAppsAsync({ _id: payload._id }))
                                .unwrap()
                                .then((res) => {
                                  toast.success(`Triggered successfully.`);
                                });
                            } catch (error) {
                              toast.error(
                                'Triggered failed, please try again in some time!'
                              );
                            }
                          }}
                          sx={{
                            cursor: 'pointer',
                            py: 2,
                            textAlign: 'center',
                          }}>
                          Build Trigger
                        </Box>
                      </>
                    )}
                    {payload && payload.lastBuild ? (
                      payload.lastBuild ? (
                        <>
                          <SHAmodal
                            open={openModal}
                            onClose={() => {
                              setOpenModal(false);
                            }}
                            _id={payload._id}
                          />
                          <Box
                            onClick={() => {
                              setOpenModal(true);
                              // console.log('anurag123',payload.lastBuild.buildId)
                            }}
                            sx={{
                              cursor: 'pointer',
                              py: 2,
                              textAlign: 'center',
                            }}>
                            Update SHA
                          </Box>
                        </>
                      ) : (
                        <></>
                      )
                    ) : null}
                  </Menu>
                </Box>
              </Box>
            </>
          )}
        </>
      );
    },
  },
];
